module.exports = __webpack_public_path__ + "img/no-active-employees.ccafbc24.png";